import { merge } from 'lodash'
import Vue from 'vue'
import Router from 'vue-router'
import Segment from './views/Segment.vue'
import Courses from './views/Courses.vue'
import Reception from './views/Reception.vue'
import Reservation from './views/Reservation.vue'
import store from './store'
import { setDimension } from '@/utils/analytics'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    ...(process.env.VUE_APP_USE_MOCK
      ? [
          {
            path: '/(index.html)?',
            component: require('./views/Index.vue').default,
            beforeEnter: ({ query: { originTo, __STATE__, ...query } }, from, next) => {
              if (__STATE__) {
                const store = require('./store').default
                store.replaceState(merge(store.state, JSON.parse(__STATE__)))
              }
              next(originTo ? { path: originTo, query, replace: true } : undefined)
            },
          },
        ]
      : []),
    {
      path: '/:segment',
      component: Segment,
      async beforeEnter(to, from, next) {
        store.commit('reception/segment', to.params.segment)
        next()
      },
      children: [
        {
          path: 'course',
          name: 'courses',
          component: Courses,
          props: true,
        },
        {
          path: 'course/:id',
          name: 'courseDetail',
          component: Courses,
          props: ({ params }) => ({ id: +params.id }),
        },
        {
          path: 'reserve',
          name: 'reception',
          component: Reception,
          props: true,
          beforeEnter(to, from, next) {
            setDimension(to.params.segment)
            next()
          },
        },
        {
          path: 'reserve/:token',
          component: Reservation,
          props: true,
          beforeEnter(to, from, next) {
            setDimension(to.params.segment, to.params.token)
            next()
          },
          children: [
            {
              path: '',
              name: 'reservation',
            },
            {
              path: 'confirm',
              name: 'confirm',
            },
          ],
        },
        {
          path: '',
          redirect: { name: 'reception' },
        },
      ],
    },
  ],
})
